import { render } from "./indexPropertyTypesComponent.vue?vue&type=template&id=ac98cb70"
import script from "./indexPropertyTypesComponent.vue?vue&type=script&lang=js"
export * from "./indexPropertyTypesComponent.vue?vue&type=script&lang=js"

import "./indexPropertyTypesComponent.vue?vue&type=style&index=0&id=ac98cb70&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__